import bizNodeModel from '../../bizNodeModel.mjs'
import FjType from './FjType.mjs'

export default bizNodeModel({
    fjTitle: {
        name: () => '关键逻辑标题',
    },

    fjTypeCode: {
        name: () => '关键逻辑类型',

        readableValue: (map, node) => {
            const {fjTypeCode} = node.data

            if (fjTypeCode) {
                const match = FjType.find(e => fjTypeCode === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    dtOprCode: {
        name: () => '表操作',
    },

    txNo: {
        name: () => '事务号',
    },

    fjDesc: {
        name: () => '关键逻辑描述',
    },

    memo: {
        name: () => '备注',
    },
})
